module.exports = __webpack_public_path__ + "static/media/logo.5dd91a35.svg";